export const globalVariable = {
     'WarehouseDeadStock' :'180'
}
export default globalVariable;